type IconProps = React.ComponentProps<'svg'>

export function XCloseIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 5.25)">
        <path
          d="M12.21967 0.21967c0.29289-0.29289 0.76765-0.29289 1.06055 0 0.29284 0.2929 0.29288 0.76767 0 1.06055l-5.46973 5.46972 5.46973 5.46973c0.29284 0.2929 0.29288 0.76767 0 1.06055-0.29287 0.29288-0.76765 0.29284-1.06055 0l-5.46973-5.46973-5.46972 5.46973c-0.29287 0.29288-0.76765 0.29284-1.06055 0-0.29289-0.29289-0.29289-0.76765 0-1.06055l5.46973-5.46973-5.46973-5.46972c-0.29289-0.29289-0.29289-0.76765 0-1.06055 0.29289-0.29289 0.76765-0.29289 1.06055 0l5.46972 5.46973 5.46973-5.46973z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
